// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ loggedIn, children }) => {
    if (!loggedIn) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default PrivateRoute;
